<template>
  <div>
    <b-collapse class="card is-bg-transparent is-no-box-shadow" aria-id="contentIdForA11y3">
      <div
        slot="trigger" 
        slot-scope="props"
        class="card-header is-no-box-shadow"
        role="button"
        aria-controls="contentIdForA11y3">
        <p class="card-header-title has-text-dark">
          <i class="fas fa-graduation-cap fa-lg"></i>&nbsp;&nbsp;&nbsp;Kelas Akademik
        </p>
      </div>
      <div class="card-table is-boxed">
        <div class="">
          <table class="table is-fullwidth">
            <tbody v-if="!isEmpty(academic_groups)">
              <tr v-for="group in academic_groups" :key="group.id">
                <td style="padding: 7px;">
                  <div class="columns is-mobile is-vcentered">
                    <div class="column is-narrow">
                      <shorticon style="margin: 0;" :shortName="group.shortName" size="small" :bgColor="group.color"></shorticon>
                    </div>
                    <div class="column">
                      <p class="title is-6 tooltip is-tooltip-multiline font-14" :data-tooltip="`${group.name} ${group.className ? '-' + group.className : ''}`">
                        <strong style="font-weight: bold;">
                          <nuxt-link class="has-text-primary" :to="{path: `/panel/classes/${group.id}`}">{{ group.name }}</nuxt-link>
                        </strong>
                      </p>
                      <p class="subtitle is-6 font-14">{{ group.className || '-' }}</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="columns is-mobile is-vcentered">
                    <div class="column has-text-centered">
                      <nuxt-link :to="{path: '/panel/classes'}"><small class="has-text-info">Lihat Semua</small></nuxt-link>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="isEmpty(academic_groups) && !loading_academic">
              <tr><td><p class="has-text-grey font-14">Data tidak ditemukan.</p></td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <footer class="card-footer" v-if="dataProviderAcademic.total <= 0 || loading_academic">
        <div class="card-footer-item">
          <div v-if="loading_academic" class="columns">
            <div class="column">
              <spinner-loading></spinner-loading>
            </div>
          </div>

          <pagination v-if="!loading_academic" :dataProvider="dataProviderAcademic" :clickHandler="getAcademicGroups"></pagination>
        </div>
      </footer>
    </b-collapse>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { GROUP } from '~/consts';

export default {
  mounted() {
    this.getAcademicGroups();
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
    }),
  },

  data() {
    return {
      loading_academic: false,
      academic_groups: [],
      dataProviderAcademic: {
        criterion: [],
        page: {
          count: 0,
          current: 1,
          limit: 3,
          next: 1,
          previous: 0,
          total: 0
        },
        sort: [
          { criteria: 'latest_post', order: 'desc', no_table: true }
        ]
      },
    }
  },

  methods: {
    getAcademicGroups(refresh = false) {
      const vm = this;

      if (vm.auth.active_pt != null) {
        vm.loading_academic = true;

        if (refresh) {
          vm.dataProviderAcademic.page['current'] = 1;
        }

        this.$axios.post(GROUP.GET_ACADEMIC, {
          university_user_id: vm.auth.active_pt.id,
          dataProvider: JSON.stringify(vm.dataProviderAcademic)
        })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            if (refresh) {
              vm.academic_groups = data.data.data;
            } else {
              let academic_group_ids = collect(vm.academic_groups).pluck('id').toArray();
              let academic_groups = collect(data.data.data).filter((g) => {
                if (academic_group_ids.indexOf(g.id) > -1) {
                  return false;
                }

                return true;
              }).toArray();
              vm.academic_groups = vm.academic_groups.concat(academic_groups);
            }

            vm.dataProviderAcademic = data.data.dataProvider;
          }

          vm.loading_academic = false;
        }).catch(() => {
          vm.loading_academic = false;
        });
      }
    },
  }
}
</script>
